import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import style from '../css/gameCategoryTab.css';
import {ASSETS_URL} from '../../../constants/endpoints';
import {calculateTimeDifference, formatTimeInSecondsToMMSS} from '../../../helpers/helperFunctions';
import {getText} from '../../../helpers/localization';
import {RES, VID} from '../../../constants/identifiers';
import {OPERATOR} from "../../../../src/constants/operator";
import {MATCHDAY_MODULE_TYPE} from "../modules/matchday/constants/identifiers";

let gameTabsUI;
let gameSubContainer;
const mapStateToProps = (state, ownProps) => {
    return {
        games: state.vpp.games,
        selectedGameIndex: state.vpp.selectedGameIndex,
        nextEventsTimeStamp: state.vpp.nextEventsTimeStamp,
        serverTimeOffset: state.vpp.serverTimeOffset
    };
};

class GameCategoryTab extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.isEventLive = false;
        this.state = {
            games: storeData.vpp.games,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
            serverTimeOffset: storeData.vpp.serverTimeOffset,
            timeLeft: this._getTimeLeft()
        };
    }

    _getTimeLeft() {
        let nextEventTime = this._getNextEventTime();
        if (nextEventTime !== undefined) {
            let timeLeft = calculateTimeDifference(new Date(Date.now() - this.state.serverTimeOffset), nextEventTime) / 1000;
            if (Math.floor(timeLeft) === 0) {
                setTimeout(() => this.isEventLive = true, 200);
                setTimeout(() => this.isEventLive = false, 8000);
            }
            return timeLeft;
        }
        return undefined;
    }

    _updateTimeLeft() {
        this.setState({
            ...this.state,
            timeLeft: this._getTimeLeft()
        });
    }

    componentDidMount() {
        this.interval = setInterval(this._updateTimeLeft.bind(this), 300);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                games: storeData.vpp.games,
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
                serverTimeOffset: storeData.vpp.serverTimeOffset,
            });
        }
    }

    _getNextEventTime() {
        let eventTime;
        let event;
        if (this.state && this.state.nextEventsTimeStamp) {
            event = this.state.nextEventsTimeStamp.find((event) => event.channel === this.props.gameCategory.games[0].channel && Number(event.eventTime) >= (new Date().getTime() - this.state.serverTimeOffset));
            if (event) {
                eventTime = Number(event.eventTime);
            }
        }

        return eventTime;
    }

    render() {
        let blinkingStyle = () => {
            let timeLeft = Math.floor(this.state.timeLeft);
            if (timeLeft < 0) {
                return style.notBlinking;
            } else if (timeLeft <= 15) {
                return style.blinkingRed;
            } else if (timeLeft <= 30) {
                return style.blinkingAmber;
            } else {
                return style.notBlinking;
            }
        };
        let controllerState = this.props.store.getState().vpp.games[this.props.gameIndex].controllerState;
        let isLive = (controllerState === VID || controllerState === RES || (controllerState != undefined && controllerState[1] !== undefined &&
            (controllerState[1] === VID || controllerState[1] === RES)));
        let isSelected = this.state.games[this.state.selectedGameIndex].categoryOrder === this.props.gameCategoryindex + 1
        let timeToDisplay = (isLive || this.isEventLive) ? getText('LIVE', this.props.store) : this.state.timeLeft !== undefined ?
            formatTimeInSecondsToMMSS(this.state.timeLeft) : '-- : --'
        let counterStyle = (isLive || this.isEventLive) ? style.live : style.counter
        let counterTextStyle = (isLive || this.isEventLive) ? style.liveText : textStyle
        let accaBonusPresent = OPERATOR.accaBoostBonusEnabled;
        let isMatchdayChannel = this.props.gameCategory.games[0].type === MATCHDAY_MODULE_TYPE;
        let gameIconSrc = `${ASSETS_URL}${this.props.gameCategory.games[0].category.assetsFolder}/${isSelected ?
            (isMatchdayChannel && accaBonusPresent ? 'tabselectedIcon_bonus.svg' : 'tabselectedIcon.svg') :
            (isMatchdayChannel && accaBonusPresent ? 'tabIcon_bonus.svg' : 'tabIcon.svg')}`
        let textStyle = isSelected ? style.selected : ''
        let iconLabelStyle = isSelected ? style.selectedIconLabel : style.iconLabel;
        let gameTabCounter = (<Fragment>{timeToDisplay}</Fragment>);

        gameSubContainer = isSelected ?
            <div id={'gameSubContainer'} className={style.gameSubCategoryContainer}>{gameTabsUI}</div> : ''
        return (
            <div
                className={`${style.gameTab} ${isSelected ? style.selected : ''}`}
                onClick={() => this.props.callback(this.props.gameIndex)}
                id={'gameCategoryTab_' + this.props.gameCategoryindex}>
                <div className={blinkingStyle()}/>
                <div className={`${counterStyle} ${counterTextStyle}`}>
                    <span>{gameTabCounter}</span>
                </div>
                <div className={style.iconContainer}>
                    <img src={gameIconSrc}
                         className={`${style.icon}`} alt={this.props.gameCategory.name}/>
                </div>
                <div
                    className={`${textStyle} ${iconLabelStyle}`}>{getText(this.props.gameCategory.name, this.props.store)}</div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(GameCategoryTab);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/gameCategoryTab.js